// 1. 외부 패키지
import Axios, { AxiosRequestConfig, CancelToken } from 'axios'


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import accountManager from '../../shared/account-manager'
import {
  BASIC_URL,
  GET,
  JSON_HEADER,
} from '../../shared/api-constant'
import {
  formGenerator,
} from '../../shared/function'


// 4. 타입


const basic = {
	getDetail: (idx: number, cancel_token: CancelToken) => {
    const account_idx = accountManager.getIdx()

    const config: AxiosRequestConfig = {
      url: `${BASIC_URL}/get_detail.php`,
      method: GET,
      params: {
        idx,
        account_idx
      },
      headers: {
        ...JSON_HEADER,
      },
      cancelToken: cancel_token,
    }
    return Axios(config)
  },
};

export default basic;